import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useMemo,
} from "react";

import RTCEECampaign from "components/RTCEE/RTCEECampaign";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import postPageVisit from "services/LogService";

export default function CEE() {
  // console.log("Page plan d'actions");
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;

  useEffect(() => {
    setPage('cee');
    postPageVisit('cee');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/cee",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"cee"}
    >
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
          <Card>
            <CardBody>
              <RTCEECampaign />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
